export default "__VITE_ASSET__8d4b1c00__"